<div (click)="toggleFollow()">
  <mat-icon *ngIf="!isFollowing">favorite_border</mat-icon>
  <mat-icon *ngIf="isFollowing">favorite</mat-icon>
</div>
